


















































import { Component, Vue } from "vue-property-decorator";
import { getLogTypeList } from "@/req/account";
import { timeOption } from "../config";

@Component({
  components: {},
})
export default class Home extends Vue {
  public options = timeOption;
  public dateTime: any = "";
  public baseList = {
    type: "",
    username: "",
    begin_time: "",
    end_time: "",
  };
  public typeList: any = [];
  public mounted() {
    this.getList();
  }
  public async getList() {
    const res = await getLogTypeList();
    if (res.code == 0) {
      this.typeList = res.data;
    }
  }
  public returnCurrent(currentPage) {
    if (typeof currentPage === "string") {
      return Number(currentPage);
    }
    return currentPage;
  }
  public changeTime(date) {
    this.baseList.begin_time = date[0];
    this.baseList.end_time = date[1];
  }
  public typeChange(val) {
    if (!val) {
      this.baseList.type = "";
    }
  }
  public reset() {
    this.dateTime = "";
    this.baseList = {
      type: "",
      username: "",
      begin_time: "",
      end_time: "",
    };
    this.search();
  }
  public search() {
    this.$emit("returnList", this.baseList);
  }
}
